import * as React from "react";
import { forwardRef } from "react";
const SvgDraggableIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 6, viewBox: "0 0 15 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.1668 0.5H0.833496V2.16667H14.1668V0.5ZM0.833496 5.5H14.1668V3.83333H0.833496V5.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDraggableIcon);
export default ForwardRef;
